<template>
  <v-menu
    transition="slide-y-transition"
    bottom
    right
    offset-y
    content-class="elevation-1 mt-sm-6 notification-wrap"
    z-index="11"
    :close-on-content-click="false"
    v-model="menuShowed"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        class="d-flex align-center p-relative notification-bell"
        v-bind="attrs"
        v-on="on"
      >
        <img
          src="@/assets/icons/bell-primary.svg"
          alt=""
          height="18"
          width="18"
          v-if="menuShowed"
        />
        <img
          src="@/assets/icons/bell-gray.svg"
          alt=""
          height="18"
          width="18"
          v-else
        />
        <div class="p-absolute unread-circle" v-if="unreadCount > 0"></div>
      </div>
    </template>
    <v-card class="rounded-10 pa-5 shadow-base notification-menu" flat>
      <div class="d-flex d-sm-none justify-start mb-5 pt-3">
        <v-icon @click="menuShowed = false" class="icongray--text"
          >mdi-close</v-icon
        >
      </div>
      <div class="d-flex align-center justify-space-between">
        <div class="heading-5 font-weight-medium">Notifications</div>
        <div class="text-5 gray--text clickable" @click="readAll">
          Mark All As Read
        </div>
      </div>
      <div :class="['notifications mt-5 px-1']">
        <div
          v-for="(notification, index) in notifications"
          :key="index"
          :class="['notification mt-2', notification.type, ,]"
        >
          <div
            v-if="notification.type === 'annoucement'"
            :class="[
              'pa-5 rounded-10',
              {
                'is-read': notification.read,
                clickable: !notification.read,
              },
            ]"
            @click="readOne(notification)"
          >
            <div class="d-flex align-baseline">
              <div
                :class="[
                  'flex-1 text-4 font-weight-medium line-height-24',
                  {
                    'black--text': notification.read,
                    'white--text': !notification.read,
                  },
                ]"
              >
                {{ notification.title }}
              </div>
              <div
                :class="[
                  'ml-5 text-5 font-weight-medium',
                  {
                    'icongray--text': notification.read,
                    'white--text': !notification.read,
                  },
                ]"
              >
                {{ $t(formatDistanceToNow(notification.createdAt)) }}
              </div>
            </div>
            <div
              :class="[
                'mt-3 text-5 line-height-24 annoucement-message',
                {
                  'gray--text': notification.read,
                  'white--text': !notification.read,
                },
              ]"
            >
              <div v-html="notification.message"></div>
            </div>
          </div>
          <div
            v-if="notification.type === 'transaction'"
            :class="[
              'p-relative border-default rounded-10 pa-5',
              { clickable: !notification.read },
            ]"
            @click="readOne(notification)"
          >
            <div class="indicator primary" v-if="!notification.read"></div>
            <div class="d-flex align-flex-start">
              <div class="flex-1 d-flex align-center">
                <img
                  :src="notification.icon"
                  alt=""
                  width="24px"
                  height="16px"
                />
                <div
                  :class="[
                    'flex-1 ml-3 line-height-24',
                    {
                      'text-4 font-weight-medium': !notification.read,
                      'text-4': notification.read,
                    },
                  ]"
                >
                  {{ $t(notification.title, notification.metadata) }}
                </div>
              </div>
              <div
                :class="[
                  'ml-5 text-5 font-weight-medium',
                  {
                    'gray--text opacity-8': notification.read,
                    'primary--text': !notification.read,
                  },
                ]"
              >
                {{ $t(formatDistanceToNow(notification.createdAt)) }}
              </div>
            </div>
            <div
              :class="[
                'mt-3 line-height-24',
                {
                  'text-5 font-weight-medium': !notification.read,
                  'text-5 gray--text': notification.read,
                },
              ]"
            >
              {{ $t(notification.message, notification.metadata) }}
            </div>
            <div class="mt-3 text-right">
              <a
                :href="notification.link"
                target="_blank"
                rel="noopener noreferrer"
                class="primary--text text-decoration-none text-5 font-weight-medium"
                >View Transaction</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 text-center" v-if="!notifications.length">
        <span>You don't have any notification.</span>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDistanceToNow } from "date-fns";
export default {
  data: () => ({
    menuShowed: false,
  }),
  computed: {
    ...mapGetters({
      unreadCount: "notification/unreadCount",
      notifications: "notification/notifications",
      isAuthenticated: "auth/isAuthenticated",
    }),
  },
  methods: {
    readOne(notification) {
      if (notification.read) return;
      this.$store.dispatch("notification/readNoti", notification);
    },
    readAll() {
      this.notifications
        .filter((noti) => !noti.read)
        .forEach((noti) => this.readOne(noti));
    },
    formatDistanceToNow(value) {
      return formatDistanceToNow(value, { addSuffix: true });
    },
  },
  watch: {
    menuShowed(value) {
      this.$nextTick(() => {
        const display = value ? "block" : "none";
        document.getElementById("menuOverlay2").style.display = display;
      });
    },
    isAuthenticated: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$store.dispatch("notification/fetchNotifications");
        }
      },
    },
  },
};
</script>

<style lang="scss" >
.notification-bell {
  .unread-circle {
    bottom: 0;
    right: -3px;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    border: 2px solid white;
    background-color: var(--v-primary-base);
  }
}
.notification-menu {
  .notifications {
    overflow: auto;
    max-height: calc(100vh - 250px);
    .notification {
      .indicator {
        left: 5px;
        top: 5px;
        position: absolute;
        width: 6px;
        height: calc(100% - 10px);
        border-radius: 50px;
      }
      &.annoucement {
        > div {
          background-color: var(--v-primary-base);
          .annoucement-message {
            a {
              color: white;
            }
          }
          &.is-read {
            background-color: #f660331a;
            .annoucement-message {
              a {
                color: var(--v-primary-base);
              }
            }
          }
        }
      }
    }
  }

  .line-height-24 {
    line-height: 24px !important;
  }
}
.notification-wrap {
  width: 460px;
  max-width: 100% !important;
  border-radius: 10px !important;
  @media (max-width: 599px) {
    width: 100vw !important;
    left: 0 !important;
    top: -12px !important;
    margin-top: 0 !important;
  }
}

.theme--light {
  .notification-menu {
    border: none !important;
  }
}
.theme--dark {
  .notification-menu {
    border: 1px solid var(--lightgray);
  }
  .notification-bell {
    .unread-circle {
      border: 2px solid #222e3b;
    }
  }
}
</style>